// This is the entry point for the home component
import React, { FC, useContext, useState } from 'react';
import AudienceList from 'Containers/AudienceList';
import IndividualList from 'Containers/IndividualList';
import { Paging, calcCurrentPage } from 'Components/Paging';
import UserDetailsContext from 'Context/userDetailsContext';
import AudienceTableHeader from 'Containers/Audience';
// Not installing this to satisfy linter for now
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery } from '@apollo/react-hooks';
import { useSelector, useDispatch } from 'react-redux';
import withErrorBoundary from 'HOC/ErrorBoundary';
import getIndividualListGQL from './gqlQuery';
import {
  addLeads,
  removeLeads,
  setCurrentPage,
} from './actions/individuallist.actions';

interface Props {
  listId?: string;
  startDate?: string;
  endDate?: string;
  filters?: any;
  Selector?: any;
}

const AudienceExplore: FC<Props> = (props: Props) => {
  const [listObj, setListObj] = useState(null);
  const [searchText, setSearchText] = useState('');
  const Dispatch = useDispatch();
  const recordsPerPage: number = 10;
  const userDetails = useContext(UserDetailsContext);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refreshList, setRefreshList] = useState(false);
  const [userInfo, setUserInfo] = useState([]);

  const { listId, startDate, endDate, filters, Selector } = props;

  const items: any[] = [{ label: 'Duplicate' }];

  const isChecked = (checkedItems: string[]) => (id: string) =>
    checkedItems.includes(id);

  const { individualList } = useSelector((selectors: any) => selectors);
  const currList = individualList.filter((list: any) => list.listId === listId);

  let currentPage =
    (currList && currList.length > 0 && currList[0].currentPage) || 1;
  const checkedItems =
    (currList && currList.length > 0 && currList[0].checkedItems) || [];
  const userIds =
    (currList && currList.length > 0 && currList[0].userIds) || [];

  const onChecked = (id: string) => {
    const { userId } = userInfo.filter((elem) => elem.userId === id)[0];
    Dispatch(addLeads({ listId, userKey: [id], userId: [userId] }));
  };

  const onUnChecked = (id: string) => {
    const { userId } = userInfo.filter((elem) => elem.userId === id)[0];
    Dispatch(removeLeads({ listId, userKey: [id], userId: [userId] }));
  };

  const onPrevPage = () => {
    currentPage = calcCurrentPage(currentPage, totalPages, -1);
    Dispatch(setCurrentPage({ listId, currentPage }));
  };
  const onNextPage = () => {
    currentPage = calcCurrentPage(currentPage, totalPages);
    Dispatch(setCurrentPage({ listId, currentPage }));
  };

  const onTotalRecordsChanged = (n: string) => {
    if (parseInt(n, 10) !== totalRecords) {
      currentPage = 1;
      Dispatch(setCurrentPage({ listId, currentPage }));
    }
    setTotalRecords(parseInt(n, 10));
  };

  const onTotalPagesChanged = (n: number) => {
    if (n !== totalPages) {
      currentPage = 1;
      Dispatch(setCurrentPage({ listId, currentPage }));
    }
    setTotalPages(n);
  };

  useQuery(getIndividualListGQL, {
    variables: {
      instId: userDetails.instId,
      accountId: userDetails.accountId,
      id: listId,
    },
    skip: !listId || listId === '-1',
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      setListObj(data && data.list);
    },
    onError: () => {
      setListObj(null);
    },
  });

  if (
    listObj &&
    listObj.accountId &&
    listObj.accountId === userDetails.accountId
  ) {
    items.push(
      { label: 'Rename' },
      { label: 'Permissions' },
      { label: 'Delete' }
    );
  }

  if (
    listObj &&
    listObj.attributes &&
    !(listObj.attributes.toLowerCase() === 'custom')
  ) {
    items.push({ label: 'Load Attributes in Explore' });
  }

  const defaultExplore = {
    name: 'Audience Explore',
    filters: filters || { opertation: 'AND' },
    sort: 'LastDateActiveWithInstitution:desc',
    columns: [
      'name',
      'relativeInterestLevel',
      'visits',
      'visitorType',
      'enroll',
      'lastActive',
    ],
  };

  const [sort, setSort] = useState(defaultExplore.sort);
  const sortUpdate = (sortBy: string) => {
    setSort(sortBy);
  };

  return (
    <>
      <AudienceTableHeader
        searchText={searchText}
        onSearch={(searchString) => setSearchText(searchString)}
        checkedItems={checkedItems}
        userIds={userIds}
        startDate={startDate}
        endDate={endDate}
        audienceTotal={totalRecords}
        checkedBoxCount={checkedItems.length}
        headerTitle={defaultExplore.name}
        listName={listObj && listObj.name}
        listId={listId}
        userKeys={checkedItems}
        setRefreshList={(val: any) => setRefreshList(val)}
        filters={defaultExplore.filters}
        items={items}
        loadAttributes={listObj && listObj.loadAttributes}
        sort={sort}
      />

      {listId !== '-1' ? (
        <IndividualList
          search={searchText}
          checkedItems={checkedItems}
          setUserInfo={setUserInfo}
          inst_id={userDetails.instId}
          account_id={userDetails.accountId}
          Selector={Selector}
          page={currentPage}
          size={recordsPerPage}
          onChecked={onChecked}
          onUnChecked={onUnChecked}
          onTotalRecordsChanged={onTotalRecordsChanged}
          onTotalPagesChanged={onTotalPagesChanged}
          isChecked={isChecked(checkedItems)}
          filters={defaultExplore.filters}
          sort={defaultExplore.sort}
          tableColumns={defaultExplore.columns}
          listId={listId}
          listName={listObj && listObj.name}
          listAccountId={listObj && listObj.accountId}
          refreshList={refreshList}
          setRefreshList={(val: any) => setRefreshList(val)}
        />
      ) : (
        <AudienceList
          search={searchText}
          checkedItems={checkedItems}
          setUserInfo={setUserInfo}
          instId={userDetails.instId}
          accountId={userDetails.accountId}
          page={currentPage}
          Selector={Selector}
          size={recordsPerPage}
          onChecked={onChecked}
          onUnChecked={onUnChecked}
          onTotalRecordsChanged={onTotalRecordsChanged}
          onTotalPagesChanged={onTotalPagesChanged}
          isChecked={isChecked(checkedItems)}
          filters={defaultExplore.filters}
          listId={listId}
          sortUpdate={sortUpdate}
          totalPages={totalPages}
          totalRecords={totalRecords}
        />
      )}

      {totalRecords > recordsPerPage && (
        <Paging
          position="right"
          page={currentPage}
          recordsPerPage={10}
          totalRecords={totalRecords}
          prev={onPrevPage}
          next={onNextPage}
          totalPages={totalPages}
        />
      )}
    </>
  );
};

AudienceExplore.defaultProps = {
  listId: '-1',
  startDate: '',
  endDate: '',
  filters: {},
  Selector: {},
};

export default withErrorBoundary(AudienceExplore);
